<template>
  <div
    :id="popupId"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h2>WARNING?</h2>
          <button
            ref="DeleteCampaignCloseButtonPopup"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <p>
            <label>
              Are you sure you want to delete this campaign?
              <br>This action cannot be undone.
            </label>
          </p>
          <div class="row">
            <div class="col-xs-6">
              <button class="btn-lg-grey" data-dismiss="modal" aria-label="Close">NO</button>
            </div>
            <div class="col-xs-6">
              <button class="btn-lg-green" @click="deleteCampaign">YES</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    popupId: {
      type: String,
      required: true
    },
    campaignId: {
      type: Number,
      required: true
    }
  },
  methods: {
    deleteCampaign () {
      if (this.campaignId === 0) {
        return false
      }
      this.$http
        .delete('plg/delete-campaign/' + this.campaignId, {
          headers: {
            'user-type': 'sadmin'
          }
        })
        .then((response) => {
          let DeleteCampaignCloseButtonPopup = this.$refs.DeleteCampaignCloseButtonPopup
          this.$notify({ type: 'success', text: 'Campaign has been deleted successfully!' })
          this.$emit('campaignDeleted', this.campaignId)
          DeleteCampaignCloseButtonPopup.click()
        }, (error) => {
          console.error('Error deleting campaign:', error)
          this.$notify({ type: 'error', text: 'Failed to delete campaign. Please try again.' })
        })
    }
  }
}
</script>

<style scoped>
p {
  color: #232323;
  font-size: 24px;
  text-align: center;
}
</style>
